import template from './pack-details.html';

export default {
  template,
  controller: 'PackDetailsController',
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/pack-details/pack-details.component.js